export default __webpack_public_path__ + "static/media/demonicwar.2992ffbd.png";